import { Component } from '@angular/core';

/**
 * The v2 phone-mockup shell (bezel, notch, "9:41 / LOMY" status bar) used by
 * every in-app preview aside (novosti, push poruke, promocije). Screen content
 * is projected; styling comes from the global `.phone` rules in
 * src/scss/v2/_v2-detail.scss.
 */
@Component({
  selector: 'app-phone-preview',
  template: `
    <div class="phone">
      <div class="phone__screen">
        <div class="phone__notch"></div>
        <div class="phone__status"><span>9:41</span><span>LOMY</span></div>
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class PhonePreviewComponent {}
